import { createFileRoute } from "@tanstack/react-router"
import { queryClient } from "@/queryClient"
import { getCourseOptions } from "@/client/@tanstack/react-query.gen"
import EditCourse from "@/routes/-pages/EditCourse"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

const COURSE_TAB_PARAMS = ["assessments", "teams", "members", "settings"] as const
type CourseTabParam = (typeof COURSE_TAB_PARAMS)[number]

/** Maps removed tab values to their replacements for backward compatibility. */
const LEGACY_TAB_MAP: Record<string, CourseTabParam> = {
  sections: "assessments",
}

export const Route = createFileRoute("/instructor/course/$courseId/")({
  validateSearch: (search: Record<string, unknown>): { tab?: CourseTabParam } => {
    const rawTab = search.tab as string | undefined
    if (rawTab !== undefined && COURSE_TAB_PARAMS.includes(rawTab as CourseTabParam)) {
      return { tab: rawTab as CourseTabParam }
    }
    if (rawTab !== undefined && rawTab in LEGACY_TAB_MAP) {
      return { tab: LEGACY_TAB_MAP[rawTab] }
    }
    return { tab: undefined }
  },
  loader: ({ params }) => {
    return runBackendModePrefetch(() =>
      queryClient.prefetchQuery(getCourseOptions({ path: { course_id: params.courseId } })),
    )
  },
  component: EditCourse,
})
